// extracted by mini-css-extract-plugin
module.exports = {"notification":"NotificationBanner_notification__1KlKO","notificationIcon":"NotificationBanner_notificationIcon__2DbVz"};